import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.53 38.44" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M1.14 5.14a.5.5 0 01-.49-.41C.41 3.54.39 2 1.07 1.13A1.9 1.9 0 012.63.5h30.78a.5.5 0 01.5.5v3.64a.5.5 0 01-.5.5z"
          fill="fj-icons-bg-color"
        />
        <path
          d="M33.41 1v3.64H1.14c-.21-1-.25-2.49.32-3.18A1.36 1.36 0 012.63 1h30.78m0-1H2.63C-.36 0-.13 3.4.16 4.83a1 1 0 001 .81h32.25a1 1 0 001-1V1a1 1 0 00-1-1z"
          fill="fj-icons-primary-color"
        />
        <path
          d="M2.75 13.83a.5.5 0 01-.49-.42L1.64 9.7a.55.55 0 01.11-.41.52.52 0 01.38-.17h31.28a.5.5 0 01.5.5v3.71a.5.5 0 01-.5.5z"
          fill="fj-icons-bg-color"
        />
        <path
          d="M33.41 9.62v3.71H2.75l-.62-3.71h31.28m0-1H2.13a1 1 0 00-1 1.16l.62 3.71a1 1 0 001 .84h30.66a1 1 0 001-1V9.62a1 1 0 00-1-1z"
          fill="fj-icons-primary-color"
        />
        <path
          d="M4.18 21.9a.5.5 0 01-.49-.42l-.62-3.71a.45.45 0 01.11-.4.48.48 0 01.38-.18H33.5a.51.51 0 01.51.48 4.65 4.65 0 01-.86 3.5 2.26 2.26 0 01-1.6.71z"
          fill="fj-icons-bg-color"
        />
        <path
          d="M33.5 17.69a4.21 4.21 0 01-.73 3.13 1.72 1.72 0 01-1.22.55H4.17l-.62-3.71H33.5m0-1H3.56a1 1 0 00-1 1.16l.62 3.71a1 1 0 001 .84H31.55c.44 0 3.23-.17 3-4.74a1 1 0 00-1-.95zM11 32.84H5.84v5.42H3.62V25.47h8.13v1.79H5.84v3.8H11zM16.92 25.47h2.21v9a4.37 4.37 0 01-.31 1.7 3.6 3.6 0 01-.82 1.22 3.79 3.79 0 01-1.32.78 5 5 0 01-1.67.27 5.93 5.93 0 01-1.68-.23 3.6 3.6 0 01-1.33-.7 3.18 3.18 0 01-.86-1.2 4.18 4.18 0 01-.31-1.69H13a2.65 2.65 0 00.15.94 1.55 1.55 0 00.4.63 1.66 1.66 0 00.62.36 2.86 2.86 0 00.8.11 2.22 2.22 0 00.79-.14 1.69 1.69 0 00.62-.43 2 2 0 00.4-.69 2.85 2.85 0 00.15-1zM31 25.47V34a4.6 4.6 0 01-.34 2 4 4 0 01-1 1.38 4.32 4.32 0 01-1.52.83 6 6 0 01-1.87.28 6.1 6.1 0 01-1.9-.28 4.23 4.23 0 01-1.52-.83 3.9 3.9 0 01-1-1.38 4.77 4.77 0 01-.38-2v-8.53h2.22V34a3.49 3.49 0 00.18 1.18 2.2 2.2 0 00.51.82 1.94 1.94 0 00.81.48 3.86 3.86 0 002.13 0 1.94 1.94 0 00.81-.48 2.2 2.2 0 00.51-.82 3.49 3.49 0 00.18-1.18v-8.53z"
          fill="fj-icons-primary-color"
        />
      </g>
    </g>
  </svg>
);

const Fju = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Fju;
